module.exports = "/_next/static/images/OSPConstr-bed685a891d1300ff00acf270245f9e7.webp";